const selectors = {
	wrapper: '.mcfly-options',
	option: 'li.option',
};

const classNames = {
	selected: 'selected',
};

const elements = document.querySelectorAll(selectors.wrapper);

elements.forEach((el) => {
	const updateValue = () => {
		const activeOption = el.querySelector(`${selectors.option}.${classNames.selected}`);
		const value = activeOption ? activeOption.getAttribute('data-value') : '';
		el.setAttribute('data-value', value);

		// Create and dispatch the custom event
		const event = new CustomEvent('selectedOption', { detail: { value } });
		document.dispatchEvent(event);
	};

	// Check for active option.
	updateValue();

	// Add event listeners.
	const options = el.querySelectorAll(selectors.option);
	options.forEach((opt) => {
		opt.addEventListener('click', () => {
			if (!opt.classList.contains(classNames.selected)) {
				// Remove selected class from all elements.
				options.forEach((opt) => {
					opt.classList.remove(classNames.selected);
				});
				// Add selected class to target element.
				opt.classList.add(classNames.selected);

				// Update active item.
				updateValue();
			}
		});
	});
});
